import { useParams } from 'react-router-dom';

import Customer from './components/Customer';
import Waiver from './components/Waiver';
import Payment from './components/Payment';

const CheckoutRouter = () => {
  const params = useParams();
  const stepKey = params.stepKey;

  if (stepKey === 'customer') {
    return <Customer cartId={params.cartId} />;
  }
  if (stepKey === 'payment') {
    return <Payment cartId={params.cartId} />;
  }
  if (stepKey.startsWith('waiver')) {
    return <Waiver cartId={params.cartId} key={stepKey} />;
  }

  return <div>CheckoutRouter</div>;
};

export default CheckoutRouter;
